import { useCallback } from 'react'

import { isValidDate } from '@sales-center/common'
import { SoldServiceAppDataModel } from '@user/store/opportunity'

export function useGetCustomFieldProps(props: SoldServiceAppDataModel) {
  const { id, required, caption, type } = props

  const name = `customFields.${id}`

  const validate = useCallback(
    (value: string | Date | null) => {
      if (!required) return

      if (type === 'Date') {
        if (value === null) return 'Required'
        else if (!isValidDate(value)) return 'Invalid Date'
      } else {
        if (value === '') return 'Required'
      }
    },
    [required, type],
  )

  return {
    name,
    validate,
    required,
    size: 'small',
    label: caption,
    fullWidth: true,
    margin: 'normal',
  }
}
